import { createIntegrationAuthenticationConfigurationClassMixin } from './IntegrationAuthenticationConfigurationMixin';

export interface OAuthConfigurationValid {
    type: 'VALID';
    accessToken: string;
}

export interface OAuthConfigurationInvalid {
    type: 'INVALID';
}

export type OAuthConfigurationUnion =
    | OAuthConfigurationInvalid
    | OAuthConfigurationValid;

export class OAuthConfiguration extends createIntegrationAuthenticationConfigurationClassMixin<
    OAuthConfigurationUnion,
    'OAUTH'
>('OAUTH') {}
